<div class="container mx-auto px-4 py-6">
  <div class="flex items-center justify-between mb-6">
    <h1 class="text-2xl font-bold">
      <span class="font-bold">
        {{ projectDetails?.name || 'Chargement...' }}
      </span>
    </h1>

    <button (click)="openQrModal()" [disabled]="!projectDetails?.qrcode"
      class="flex items-center gap-2 bg-gray-100 hover:bg-gray-200 border border-gray-200 text-orange-500 font-medium px-4 py-2 rounded-md transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_4123_2628)">
          <path
            d="M5 1H1V5H5V1ZM6 0V6H0V0H6ZM2 2H4V4H2V2ZM15 1H11V5H15V1ZM16 0V6H10V0H16ZM12 2H14V4H12V2ZM5 11H1V15H5V11ZM6 10V16H0V10H6ZM2 12H4V14H2V12ZM7 0H8V1H7V0ZM8 1H9V2H8V1ZM7 2H8V3H7V2ZM8 3H9V4H8V3ZM7 4H8V5H7V4ZM8 5H9V6H8V5ZM7 6H8V7H7V6ZM7 8H8V9H7V8ZM8 9H9V10H8V9ZM7 10H8V11H7V10ZM8 11H9V12H8V11ZM7 12H8V13H7V12ZM8 13H9V14H8V13ZM7 14H8V15H7V14ZM8 15H9V16H8V15ZM15 8H16V9H15V8ZM1 8H2V9H1V8ZM2 7H3V8H2V7ZM0 7H1V8H0V7ZM4 7H5V8H4V7ZM5 8H6V9H5V8ZM6 7H7V8H6V7ZM9 8H10V9H9V8ZM10 7H11V8H10V7ZM11 8H12V9H11V8ZM12 7H13V8H12V7ZM13 8H14V9H13V8ZM14 7H15V8H14V7ZM15 10H16V11H15V10ZM9 10H10V11H9V10ZM10 9H11V10H10V9ZM11 10H12V11H11V10ZM13 10H14V11H13V10ZM14 9H15V10H14V9ZM15 12H16V13H15V12ZM9 12H10V13H9V12ZM10 11H11V12H10V11ZM12 11H13V12H12V11ZM13 12H14V13H13V12ZM14 11H15V12H14V11ZM15 14H16V15H15V14ZM10 13H11V14H10V13ZM11 14H12V15H11V14ZM12 13H13V14H12V13ZM13 14H14V15H13V14ZM10 15H11V16H10V15ZM12 15H13V16H12V15ZM14 15H15V16H14V15Z"
            fill="#FF5C02" />
        </g>
        <defs>
          <clipPath id="clip0_4123_2628">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
      {{ t('projectDetail.viewQrCode') }}
    </button>
  </div>

  <!-- Navigation Tabs - Continu avec le header -->
  <nav class="border-t border-gray-100 bg-white rounded-b-lg shadow-sm px-4 sm:px-6 pb-4 sm:pb-6 pt-4 overflow-x-auto">
    <ul class="flex space-x-4 sm:space-x-6 lg:space-x-10 text-sm sm:text-base lg:text-lg min-w-max">
      <!-- Masqué: presentation -->
      <!-- <li [class.border-b-2]="activeTab === 'presentation'" [class.border-orange-500]="activeTab === 'presentation'"
        [class.text-orange-500]="activeTab === 'presentation'" class="pb-2 flex-shrink-0">
        <a (click)="setActiveTab('presentation')" class="font-medium cursor-pointer whitespace-nowrap">{{
          t('projectDetail.presentation') }}</a>
      </li> -->
      <!-- Masqué: dashboard -->
      <!-- <li [class.border-b-2]="activeTab === 'dashboard'" [class.border-orange-500]="activeTab === 'dashboard'"
        [class.text-orange-500]="activeTab === 'dashboard'" class="pb-2 flex-shrink-0">
        <a (click)="setActiveTab('dashboard')" class="font-medium cursor-pointer whitespace-nowrap">{{
          t('projectDetail.dashboard') }}</a>
      </li> -->
      <li [class.border-b-2]="activeTab === 'team'" [class.border-orange-500]="activeTab === 'team'"
        [class.text-orange-500]="activeTab === 'team'" class="pb-2 flex-shrink-0">
        <a (click)="setActiveTab('team')" class="font-medium cursor-pointer whitespace-nowrap">{{
          t('projectDetail.team') }}</a>
      </li>
      <li [class.border-b-2]="activeTab === 'tasks'" [class.border-orange-500]="activeTab === 'tasks'"
        [class.text-orange-500]="activeTab === 'tasks'" class="pb-2 flex-shrink-0">
        <a (click)="setActiveTab('tasks')" class="font-medium cursor-pointer whitespace-nowrap">{{
          t('projectDetail.tasks') }}</a>
      </li>
      <li [class.border-b-2]="activeTab === 'attendance-report'"
        [class.border-orange-500]="activeTab === 'attendance-report'"
        [class.text-orange-500]="activeTab === 'attendance-report'" class="pb-2 flex-shrink-0">
        <a (click)="setActiveTab('attendance-report')" class="font-medium cursor-pointer whitespace-nowrap">{{
          t('projectDetail.attendanceReport') }}</a>
      </li>
      <!-- Masqué: lots -->
      <!-- <li [class.border-b-2]="activeTab === 'lots'" [class.border-orange-500]="activeTab === 'lots'"
        [class.text-orange-500]="activeTab === 'lots'" class="pb-2 flex-shrink-0">
        <a (click)="setActiveTab('lots')" class="font-medium cursor-pointer whitespace-nowrap">{{
          t('projectDetail.lots') }}</a>
      </li> -->
      <!-- Masqué: documents -->
      <!-- <li [class.border-b-2]="activeTab === 'documents'" [class.border-orange-500]="activeTab === 'documents'"
        [class.text-orange-500]="activeTab === 'documents'" class="pb-2 flex-shrink-0">
        <a (click)="setActiveTab('documents')" class="font-medium cursor-pointer whitespace-nowrap">{{
          t('projectDetail.documents') }}</a>
      </li> -->
      <!-- Masqué: stock -->
      <!-- <li [class.border-b-2]="activeTab === 'stock'" [class.border-orange-500]="activeTab === 'stock'"
        [class.text-orange-500]="activeTab === 'stock'" class="pb-2 flex-shrink-0">
        <a (click)="setActiveTab('stock')" class="font-medium cursor-pointer whitespace-nowrap">{{
          t('projectDetail.stock') }}</a>
      </li> -->
      <!-- Masqué: signalement -->
      <!-- <li [class.border-b-2]="activeTab === 'signalement'" [class.border-orange-500]="activeTab === 'signalement'"
        [class.text-orange-500]="activeTab === 'signalement'" class="pb-2 flex-shrink-0">
        <a (click)="setActiveTab('signalement')" class="font-medium cursor-pointer whitespace-nowrap">{{
          t('projectDetail.alert') }}</a>
      </li> -->
      <!-- Masqué: etude-bet -->
      <!-- <li [class.border-b-2]="activeTab === 'etude-bet'" [class.border-orange-500]="activeTab === 'etude-bet'"
        [class.text-orange-500]="activeTab === 'etude-bet'" class="pb-2 flex-shrink-0">
        <a (click)="setActiveTab('etude-bet')" class="font-medium cursor-pointer whitespace-nowrap">{{
          t('projectDetail.studyBet') }}</a>
      </li> -->
      <li [class.border-b-2]="activeTab === 'pointing-adress'"
        [class.border-orange-500]="activeTab === 'pointing-adress'"
        [class.text-orange-500]="activeTab === 'pointing-adress'" class="pb-2 flex-shrink-0">
        <a (click)="setActiveTab('pointing-adress')" class="font-medium cursor-pointer whitespace-nowrap">{{
          t('projectDetail.pointingAddress') }}</a>
      </li>
      <li [class.border-b-2]="activeTab === 'leaves'" [class.border-orange-500]="activeTab === 'leaves'"
        [class.text-orange-500]="activeTab === 'leaves'" class="pb-2 flex-shrink-0">
        <a (click)="setActiveTab('leaves')" class="font-medium cursor-pointer whitespace-nowrap">Congés</a>
      </li>
    </ul>
  </nav>
</div>

<!-- Content based on active tab -->
@switch (activeTab) {
@case ('team') {
<app-team-list></app-team-list>
}
@case ('tasks') {
<app-task-board></app-task-board>
}
@case ('documents') {
<app-documents></app-documents>
}
@case ('lots') {
<app-lots-subcontractors></app-lots-subcontractors>
}
@case ('stock') {
<app-stock></app-stock>
}
@case ('etude-bet') {
<app-etude-bet></app-etude-bet>
}
@case ('signalement') {
<app-project-alert></app-project-alert>
}
@case ('presentation') {
<app-project-presentation></app-project-presentation>
}
@case ('pointing-adress') {
<app-pointing-adress></app-pointing-adress>
}
@case ('attendance-report') {
<app-attendance-report></app-attendance-report>
}
@case ('leaves') {
<app-leave-management></app-leave-management>
}
@default {
<div>{{ t('projectDetail.selectTab') }}</div>
}
}

<!-- ✅ MODAL QR CODE -->
<div *ngIf="showQrModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
  (click)="closeQrModal()">
  <div class="bg-white rounded-lg shadow-lg w-[380px] p-6 relative" (click)="$event.stopPropagation()">

    <!-- Bouton fermer -->
    <button (click)="closeQrModal()"
      class="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-xl font-semibold">
      ✕
    </button>

    <h2 class="text-lg font-semibold mb-4">{{ t('projectDetail.qrCode') }}</h2>

    <!-- Chargement -->
    <div *ngIf="isLoadingProject" class="flex flex-col items-center py-8">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mb-3"></div>
      <p class="text-gray-500 text-sm">{{ t('projectDetail.loading') }}</p>
    </div>

    <!-- Erreur -->
    <div *ngIf="projectError && !isLoadingProject" class="flex flex-col items-center py-8">
      <svg class="w-12 h-12 text-red-500 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="text-red-500 text-sm text-center">{{ projectError }}</p>
    </div>

    <!-- Contenu du QR Code -->
    <div *ngIf="!isLoadingProject && !projectError && projectDetails" class="flex flex-col items-center">

      <!-- Image QR Code -->
      <div class="mb-3 bg-white p-4 rounded-lg border-2 border-gray-200">
        <img *ngIf="qrCodeDataUrl" [src]="qrCodeDataUrl" alt="QR Code du projet" class="w-40 h-40 object-contain"
          (error)="handleQrCodeError()">

        <div *ngIf="!qrCodeDataUrl" class="w-40 h-40 bg-gray-100 flex flex-col items-center justify-center gap-2">
          <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z">
            </path>
          </svg>
          <p class="text-xs text-gray-500 text-center px-2">{{ t('projectDetail.qrUnavailable') }}</p>
        </div>
      </div>

      <p class="text-gray-500 text-sm text-center mb-4">
        {{ t('projectDetail.scanMessage') }}
      </p>

      <!-- Informations du projet -->
      <div class="w-full space-y-2 text-sm">
        <div class="flex justify-between">
          <span class="text-gray-600">{{ t('projectDetail.project') }}</span>
          <span class="font-medium text-right max-w-[200px] truncate" [title]="projectDetails.name">
            {{ projectDetails.name }}
          </span>
        </div>

        <div class="flex justify-between">
          <span class="text-gray-600">{{ t('projectDetail.status') }}</span>
          <span [class]="getConstructionStatus().class" class="px-2 py-0.5 rounded-full text-xs font-medium">
            {{ getConstructionStatus().label }}
          </span>
        </div>

        <div class="flex justify-between">
          <span class="text-gray-600">{{ t('projectDetail.updateDate') }}</span>
          <span class="font-medium">{{ getLastUpdateDate() }}</span>
        </div>

        <div *ngIf="projectDetails.address" class="flex justify-between">
          <span class="text-gray-600">{{ t('projectDetail.address') }}</span>
          <span class="font-medium text-right max-w-[200px] truncate" [title]="projectDetails.address">
            {{ projectDetails.address }}
          </span>
        </div>
      </div>

      <!-- Boutons d'action -->
      <div class="flex justify-between w-full mt-6 gap-3">
        <button (click)="printQrCode()" [disabled]="!qrCodeDataUrl"
          class="flex-1 flex items-center justify-center gap-2 border border-gray-300 px-3 py-2 rounded-md hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          <svg width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.25 8V5H8.25V8H6.25V3H18.25V8H16.25ZM18.25 12.5C18.5333 12.5 18.771 12.404 18.963 12.212C19.155 12.02 19.2507 11.7827 19.25 11.5C19.2493 11.2173 19.1533 10.98 18.962 10.788C18.7707 10.596 18.5333 10.5 18.25 10.5C17.9667 10.5 17.7293 10.596 17.538 10.788C17.3467 10.98 17.2507 11.2173 17.25 11.5C17.2493 11.7827 17.3453 12.0203 17.538 12.213C17.7307 12.4057 17.968 12.5013 18.25 12.5ZM16.25 19V15H8.25V19H16.25ZM18.25 21H6.25V17H2.25V11C2.25 10.15 2.54167 9.43767 3.125 8.863C3.70833 8.28833 4.41667 8.00067 5.25 8H19.25C20.1 8 20.8127 8.28767 21.388 8.863C21.9633 9.43833 22.2507 10.1507 22.25 11V17H18.25V21ZM20.25 15V11C20.25 10.7167 20.154 10.4793 19.962 10.288C19.77 10.0967 19.5327 10.0007 19.25 10H5.25C4.96667 10 4.72933 10.096 4.538 10.288C4.34667 10.48 4.25067 10.7173 4.25 11V15H6.25V13H18.25V15H20.25Z"
              fill="#2C3E50" />
          </svg>
          <span class="text-sm">{{ t('projectDetail.print') }}</span>
        </button>

        <button (click)="downloadQrCode()" [disabled]="!qrCodeDataUrl"
          class="flex-1 flex items-center justify-center gap-2 text-orange-600 border border-orange-600 px-3 py-2 rounded-md hover:bg-orange-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          <svg width="20" height="20" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.25 15.577L8.711 12.039L9.419 11.319L11.75 13.65V5H12.75V13.65L15.08 11.32L15.789 12.039L12.25 15.577ZM6.866 19C6.40533 19 6.021 18.846 5.713 18.538C5.405 18.23 5.25067 17.8453 5.25 17.384V14.961H6.25V17.384C6.25 17.538 6.314 17.6793 6.442 17.808C6.57 17.9367 6.711 18.0007 6.865 18H17.635C17.7883 18 17.9293 17.936 18.058 17.808C18.1867 17.68 18.2507 17.5387 18.25 17.384V14.961H19.25V17.384C19.25 17.8447 19.096 18.229 18.788 18.537C18.48 18.845 18.0953 18.9993 17.634 19H6.866Z"
              fill="#FF5C02" />
          </svg>
          <span class="text-sm">{{ t('projectDetail.download') }}</span>
        </button>
      </div>
    </div>
  </div>
</div>